// Iter 108v — Shared helpers extracted from Helpdesk.jsx.
//
// The Helpdesk page grew past 1200 lines with 5+ components sharing the
// same file scope, which made hooks hard to reason about (any state
// change in a sub-component would re-render the whole page). Splitting
// into per-component files keeps hook order predictable and shrinks
// each file to something a reviewer can hold in their head.

export const COLUMNS = [
  { key: "new",         label: "New",         tint: "bg-slate-100 text-slate-700 border-slate-200" },
  { key: "in_progress", label: "In Progress", tint: "bg-amber-50 text-amber-700 border-amber-200" },
  { key: "on_hold",     label: "On Hold",     tint: "bg-purple-50 text-purple-700 border-purple-200" },
  { key: "solved",      label: "Closed",      tint: "bg-emerald-50 text-emerald-700 border-emerald-200" },
];

export const PRIORITIES = ["low", "normal", "high", "urgent"];
export const PRIORITY_TINT = {
  low:    "bg-slate-100 text-slate-600",
  normal: "bg-sky-100 text-sky-700",
  high:   "bg-amber-100 text-amber-800",
  urgent: "bg-rose-100 text-rose-800",
};

export const TABS_LS_KEY = "helpdesk_open_tabs_v1";

export function loadTabs() {
  try { return JSON.parse(localStorage.getItem(TABS_LS_KEY) || "[]"); } catch { return []; }
}
export function saveTabs(tabs) {
  try { localStorage.setItem(TABS_LS_KEY, JSON.stringify(tabs)); } catch { /* quota */ }
}

export function fmt(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const diff = (Date.now() - d.getTime()) / 60000;
  if (diff < 1) return "just now";
  if (diff < 60) return `${Math.floor(diff)}m ago`;
  if (diff < 60 * 24) return `${Math.floor(diff / 60)}h ago`;
  return d.toLocaleDateString();
}

export function fmtMins(m) {
  m = Math.max(0, Math.round(m));
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d ${h % 24}h`;
}

// Human-readable countdown/overdue label for an ISO due date.
// Returns { label, tone } where tone ∈ ok|warn|late|done.
export function slaCountdown(dueIso, doneIso) {
  if (!dueIso) return null;
  const due  = new Date(dueIso).getTime();
  const done = doneIso ? new Date(doneIso).getTime() : null;
  if (done && done <= due) return { label: `on time · ${fmtMins((due - done) / 60000)} left`, tone: "done" };
  if (done && done > due)  return { label: `late by ${fmtMins((done - due) / 60000)}`, tone: "late" };
  const diffMin = (due - Date.now()) / 60000;
  if (diffMin < 0)   return { label: `overdue ${fmtMins(-diffMin)}`, tone: "late" };
  if (diffMin < 60)  return { label: `due in ${Math.round(diffMin)}m`, tone: "warn" };
  return { label: `due in ${fmtMins(diffMin)}`, tone: "ok" };
}

export const SLA_TONE = {
  ok:   "bg-emerald-50 text-emerald-700 border-emerald-200",
  warn: "bg-amber-50 text-amber-800 border-amber-200",
  late: "bg-rose-50 text-rose-700 border-rose-200",
  done: "bg-slate-100 text-slate-500 border-slate-200",
};

export function fmtStamp(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleString();
}
